export type PiercingPaymentMethod = 'card' | 'cash' | 'bank_transfer';
export type OnlineBookingPaymentMethod = 'CARD' | 'DIGITAL_WALLET';

export interface PaymentMethodOption<TMethod extends string> {
  value: TMethod;
  labelKey: string;
}

export const PIERCING_PAYMENT_METHOD_OPTIONS: PaymentMethodOption<PiercingPaymentMethod>[] = [
  { value: 'card', labelKey: 'piercingBooking.step5.methods.card' },
  { value: 'cash', labelKey: 'piercingBooking.step5.methods.cash' },
  { value: 'bank_transfer', labelKey: 'piercingBooking.step5.methods.bankTransfer' },
];

export const ONLINE_BOOKING_PAYMENT_METHOD_OPTIONS: PaymentMethodOption<OnlineBookingPaymentMethod>[] = [
  { value: 'CARD', labelKey: 'onlineBooking.payment.card' },
  { value: 'DIGITAL_WALLET', labelKey: 'onlineBooking.payment.digitalWallet' },
];

// Change these lists to expose additional payment methods in the booking flows.
export const ENABLED_PIERCING_PAYMENT_METHODS: readonly PiercingPaymentMethod[] = ['card'];
export const ENABLED_ONLINE_BOOKING_PAYMENT_METHODS: readonly OnlineBookingPaymentMethod[] = ['CARD'];

export const getEnabledPaymentMethods = <TMethod extends string>(
  options: PaymentMethodOption<TMethod>[],
  enabledMethods: readonly TMethod[]
): PaymentMethodOption<TMethod>[] => (
  options.filter((option) => enabledMethods.includes(option.value))
);

export const ENABLED_PIERCING_PAYMENT_METHOD_OPTIONS = getEnabledPaymentMethods(
  PIERCING_PAYMENT_METHOD_OPTIONS,
  ENABLED_PIERCING_PAYMENT_METHODS
);

export const ENABLED_ONLINE_BOOKING_PAYMENT_METHOD_OPTIONS = getEnabledPaymentMethods(
  ONLINE_BOOKING_PAYMENT_METHOD_OPTIONS,
  ENABLED_ONLINE_BOOKING_PAYMENT_METHODS
);
